import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';

const Warning = props => {
    const theme = useTheme();
    return (
        <div style={{ color: theme.palette.warning.main }}>
            { props.children }
        </div>
    );
};

Warning.defaultProps = {

};

Warning.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Warning;
